import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes';
import { ContentfulModule } from '~contentful/contentful.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import * as COMPONENTS from './components';
import * as DIRECTIVES from './directives';
import * as SERVICES from './services';
import * as VIEWS from './views';
import * as SHAREDDATA from 'src/app/shared-data';
import { environment } from 'src/environments/environment';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    VIEWS.HomeViewComponent,
    VIEWS.CheckoutViewComponent,
    VIEWS.CompleteViewComponent,
    VIEWS.ErrorViewComponent,
    VIEWS.ErrorUnavailableViewComponent,
    VIEWS.PendingComponent,
    COMPONENTS.GiftCardComponent,
    COMPONENTS.GiftCardListComponent,
    COMPONENTS.HeaderComponent,
    COMPONENTS.HeaderDropDownComponent,
    COMPONENTS.SectionContentComponent,
    COMPONENTS.FooterComponent,
    COMPONENTS.MobileFooterComponent,
    COMPONENTS.LoaderComponent,
    COMPONENTS.LoaderInnerComponent,
    COMPONENTS.NewDesignVariantComponent,
    COMPONENTS.SelectOptionComponent,
    COMPONENTS.SpinnerComponent,
    COMPONENTS.BuyForFriendComponent,
    COMPONENTS.GiphyComponent,
    COMPONENTS.GiftCardCategoryComponent,
    COMPONENTS.CountrySwitcherComponent,
    COMPONENTS.SlideMenuComponent,
    COMPONENTS.DatePickerComponent,
    DIRECTIVES.RouterBackDirective,
    DIRECTIVES.OnlyNumber,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AppRoutes,
    HttpClientModule,
    ContentfulModule,
    MaterialModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [`${environment.apiHost}`],
        sendAccessToken: true,
      },
    }),
  ],
  providers: [
    SERVICES.GiftCardsService,
    SERVICES.CheckoutService,
    SERVICES.LoaderService,
    CookieService,
    SHAREDDATA.SelectOptionService,
    SHAREDDATA.GiftcardCategoryService,
    SHAREDDATA.CheckoutStateService,
    SERVICES.ValidationService,
    SERVICES.GiphyService,
    SERVICES.AuthService,
    SERVICES.AuthGuardService,
    SERVICES.ThanksScriptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SERVICES.UnauthorizedErrorInterceptor,
      multi: true,
    },
    SERVICES.UserService,
    SERVICES.TrxService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
